import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import * as yup from 'yup';
import { useFormik } from 'formik';
import api from '../../../../../components/api';

function useRoutesAddRoute() {
  const { id } = useParams();
  const navigation = useNavigate();

  /* state management for react query fetch management */
  const { isLoading: loadingSubmit, mutate: mutateSubmit } = useMutation(!id ? api.routes.add : api.routes.update, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log(res);
      alert('success');
      navigation('/routes/route');
    },
    onError: (err) => {
      console.log('err', err);
      alert('error');
    },
  });

  const {
    data: dataDetail,
  } = useQuery(['getById', 'routes', id], () => {
    if (id) return api.routes.getById(id);
    return null;
  });

  const resDataDetail = React.useMemo(() => (
    dataDetail?.data?.data
  ), [dataDetail]);

  /* Get Driver list */
  const { data, isLoading, error } = useQuery(
    'getAllDrivers',
    () => api.routes.getAllDrivers(),
  );

  const driverList = () => data?.data?.data?.map((x: any) => {
    const { firstname, lastname, id: idDriver } = x;
    return {
      value: idDriver,
      label: `${firstname} ${lastname}`,
    };
  });

  /* form validation */
  /* change required function for showing error massage like you want */
  const yupSchemaAdd = yup.object({
    name: yup.string().required(),
    day: yup.number().required(),
    userId: yup.number().required(),
    // clients: yup.array().required(),
  });

  const yupSchemaUpdate = yup.object({
    routeId: yup.number().required(),
    name: yup.string().required(),
    day: yup.number().required(),
    userId: yup.number().required(),
    // clients: yup.array().required(),
  });

  /* form handler */
  const formik = useFormik({
    initialValues: {
      routeId: id ?? '',
      name: '',
      day: '',
      userId: '',
      clients: [],
      repeat: false,
    },
    validationSchema: id ? yupSchemaUpdate : yupSchemaAdd,
    onSubmit: (values) => {
      mutateSubmit(values);
    },
  });

  React.useEffect(() => {
    if (dataDetail && id) {
      const getByIdData = dataDetail?.data?.data;
      formik.setFieldValue('name', getByIdData?.name ?? '');
      formik.setFieldValue('day', getByIdData?.day ?? '');
      formik.setFieldValue('userId', getByIdData?.user?.id ?? '');

      const clientsId = getByIdData?.clients?.map((x: any) => x.id);
      formik.setFieldValue('clients', clientsId ?? []);
    }
  }, [dataDetail]);

  return {
    id,
    driverList,
    isLoading,
    error,
    formik,
    resDataDetail,
    loadingSubmit,
  };
}

export default useRoutesAddRoute;
